import * as React from 'react';
import { Heading, Paragraph } from '@hungryroot/ramen';

import styles from './AlreadyHaveAnAccount.module.css';

type Props = {
  className?: string;
  onLoginClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  nextRedirect?: string;
};

export function AlreadyHaveAnAccount({
  className,
  onLoginClick,
  nextRedirect,
}: Props) {
  return (
    <div className={className}>
      <Paragraph className={styles.login} variant="body">
        Already have an account?
      </Paragraph>{' '}
      <Heading className={styles['login-link']} variant="H6">
        <a
          onClick={onLoginClick}
          href={`/login/${nextRedirect ? `?next=${nextRedirect}` : ''}`}
        >
          Login
        </a>
      </Heading>
    </div>
  );
}
